export default function detection (agent) {
  let comp_agent = agent.indexOf("hisense") != -1 || agent.indexOf("vidaa") != -1;
  if (comp_agent) {
    console.info ("[Hisense detection] detected");
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/hisense/detection.js